import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';

/**
 * Required fields match AssessmentV2 RelativesAbroadForm validate():
 * relation, country, region, residency_status, age — required
 * marital_status, residence_since, nationality, country_of_birth — optional
 * (UK UI shows the optional fields; still not required by old validate())
 */
export const relativeAbroadItemSchema = Yup.object({
    relation: validateField(ValidationType.STRING),
    country: validateField(ValidationType.STRING),
    region: validateField(ValidationType.STRING),
    residency_status: validateField(ValidationType.STRING),
    age: Yup.mixed().test('age-required', 'Age is required', (value) => {
        if (value === '' || value === null || value === undefined) return false;
        const n = Number(value);
        return !Number.isNaN(n) && n > 0;
    }),
    country_of_birth: validateField(ValidationType.STRING, false),
    marital_status: validateField(ValidationType.STRING, false),
    nationality: validateField(ValidationType.STRING, false),
    residence_since: Yup.mixed().nullable(),
});

export const relativesAbroadValidationSchema = Yup.object({
    has_relatives: Yup.boolean().nullable(),
    relatives: Yup.array().when('has_relatives', {
        is: true,
        then: (schema) => schema.of(relativeAbroadItemSchema).min(1),
        otherwise: () => Yup.array().notRequired(),
    }),
});
